import type * as Sentry from '@sentry/remix';

export function getMessageFilters() {
  return [
    'Failed to fetch',
    'NetworkError',
    'Load failed',
    'InvalidStateError',
    'UnhandledRejection',
    /Unexpected token.+not valid JSON/i,
    "Cannot read properties of null (reading 'document')",
    'a.contentWindow.document',
    '__CF$cv',
    '__CFScv',
    'window.webkit.messageHandlers',
    'There was an error during concurrent rendering',
  ];
}

export function getStacktraceFilters() {
  return ['googletagmanager.com/gtm.js', 'cdn.birdie.so'];
}

export function sentryClientFilter(event: Sentry.ErrorEvent, _hint: Sentry.EventHint) {
  if (!event || !event.exception) return true;

  // Filter exception type/message (these are transient errors and just adds noise to Sentry)
  const filterPatterns = getMessageFilters();
  const filtered = event.exception.values?.some((e) =>
    filterPatterns.some((p) =>
      p instanceof RegExp ? p.test(e.type ?? '') || p.test(e.value ?? '') : e.type?.includes(p) || e.value?.includes(p),
    ),
  );

  // Exclude certain patterns from being sent to sentry
  // Array of regex patterns to match against the filename/abs_path of the frame
  const excludePatterns = getStacktraceFilters();
  const excluded = event.exception.values?.some((e) =>
    e.stacktrace?.frames?.some((f) =>
      excludePatterns.some((p: string | RegExp) =>
        p instanceof RegExp
          ? p.test(f.filename ?? '') || p.test(f.abs_path ?? '')
          : f.filename?.includes(p) || f.abs_path?.includes(p),
      ),
    ),
  );
  if (filtered || excluded) {
    return true;
  }
  return false;
}
